import { useAiGenerationHistoryStore } from '@/stores/ai-upload/AiGenerationHistoryStore';
import { useAiPersonalizationStore } from '@/stores/ai-upload/AiPersonalizationStore';
import { watch } from 'vue';

// Text is scoped to its generation: swap the panel's text to the version on screen
export function useAiPersonalizationScope(): void {
    const store = useAiPersonalizationStore();
    const historyStore = useAiGenerationHistoryStore();

    watch(
        () => historyStore.selectedEntryId,
        (entryId: string | undefined) => {
            if (entryId === undefined) {
                store.restoreLiveText();

                return;
            }

            // Parking is idempotent: moving between earlier versions leaves the first park alone
            store.parkLiveText();
            store.loadVersionText(historyStore.selectedEntry?.personalization ?? []);
        },
    );
}
